import React from "react";
import { Box, Typography, Radio, Checkbox, IconButton, TextField } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";

import GoogleIcon from "../../../../icon/GoogleIcon";
import {
  CHOICE_OPTION_EDITOR_DEFAULTS,
  CHOICE_OPTION_EDITOR_TEXTS,
  CHOICE_OPTION_EDITOR_STYLES,
  CHOICE_OPTION_CONTROL_SX,
  CHOICE_OPTION_INPUT_SX,
  CHOICE_OPTION_DELETE_BUTTON_SX,
  CHOICE_OPTION_ERROR_TEXT_SX,
  CHOICE_OPTION_ADD_ACTION_SX
} from "../constants/constantsSurveys";

export default function ChoiceOptionsEditor({
  type = CHOICE_OPTION_EDITOR_DEFAULTS.type,
  options = CHOICE_OPTION_EDITOR_DEFAULTS.options,
  inputRefs,
  getInputValue,
  onOptionChange,
  onOptionKeyDown,
  onAddOption,
  onDeleteOption,
  renderOptionActions,
  renderChildren,
  rowSx = CHOICE_OPTION_EDITOR_DEFAULTS.rowSx,
  inputSx = CHOICE_OPTION_EDITOR_DEFAULTS.inputSx,
  addActionText = CHOICE_OPTION_EDITOR_TEXTS.addAction,
  addActionSx = CHOICE_OPTION_EDITOR_DEFAULTS.addActionSx,
  shouldValidate
}) {
  const Control = type === CHOICE_OPTION_EDITOR_DEFAULTS.multipleChoiceType ? Checkbox : Radio;

  return (
    <Box sx={CHOICE_OPTION_EDITOR_STYLES.container}>
      {options.map((option, optionIndex) => {
        const hasOptionError = Boolean(
          shouldValidate && (!option.label || option.label.trim() === "")
        );

        return (
          <Box
            key={option.id || optionIndex}
            sx={CHOICE_OPTION_EDITOR_STYLES.optionWrapper}
          >
            <Box
              sx={{
                ...CHOICE_OPTION_EDITOR_STYLES.optionRow,
                borderColor: hasOptionError
                  ? CHOICE_OPTION_EDITOR_STYLES.errorBorderColor
                  : CHOICE_OPTION_EDITOR_STYLES.defaultBorderColor,
                ...rowSx
              }}
            >
              <Box sx={CHOICE_OPTION_EDITOR_STYLES.optionContent}>
                <Control
                  checked={false}
                  size="small"
                  onChange={() => {}}
                  sx={CHOICE_OPTION_CONTROL_SX}
                />

                <TextField
                  inputRef={(el) => {
                    if (inputRefs?.current) {
                      inputRefs.current[optionIndex] = el;
                    }
                  }}
                  variant="standard"
                  error={hasOptionError}
                  value={getInputValue(option, optionIndex)}
                  onChange={(e) => onOptionChange(optionIndex, e.target.value)}
                  onKeyDown={onOptionKeyDown}
                  placeholder={`${CHOICE_OPTION_EDITOR_TEXTS.optionPlaceholder} ${optionIndex + 1}`}
                  InputProps={{ disableUnderline: true }}
                  sx={{
                    ...CHOICE_OPTION_INPUT_SX,
                    ...inputSx
                  }}
                />
              </Box>

              <Box sx={CHOICE_OPTION_EDITOR_STYLES.actionsContainer}>
                {renderOptionActions?.(option, optionIndex)}

                {options.length > 1 && (
                  <IconButton
                    size="small"
                    disableRipple
                    onClick={() => onDeleteOption(optionIndex)}
                    sx={CHOICE_OPTION_DELETE_BUTTON_SX}
                  >
                    <GoogleIcon
                      name="delete_forever"
                      size={20}
                      filled={true}
                    />
                  </IconButton>
                )}
              </Box>
            </Box>

            {hasOptionError && (
              <Typography sx={CHOICE_OPTION_ERROR_TEXT_SX}>
                {CHOICE_OPTION_EDITOR_TEXTS.requiredOption}
              </Typography>
            )}

            {renderChildren?.(option, optionIndex)}
          </Box>
        );
      })}

      <Typography
        onClick={onAddOption}
        sx={{
          ...CHOICE_OPTION_ADD_ACTION_SX,
          ...addActionSx
        }}
      >
        <AddCircleIcon sx={{ fontSize: 18 }} />
        {addActionText}
      </Typography>
    </Box>
  );
}